/* @flow */

import React from 'react';
import { Link } from 'react-router-dom';
import { Popup, Icon } from 'semantic-ui-react';
import cx from 'classnames';
import { isPageSecured } from 'catalog/plugin';

type Props = {
  page: CatalogPage,
};

const buttonClass = (page: CatalogPage) =>
  cx('ui icon button', {
    red: isPageSecured(page),
  });

const iconName = (page: CatalogPage) =>
  (isPageSecured(page) ? 'lock' : 'unlock alternate');

const SecurityButton = ({ page }: Props) => (
  <Popup
    trigger={
      <Link to={`/pages/${page.id}/secure`} className={buttonClass(page)}>
        <Icon name={iconName(page)} />
      </Link>
    }
    content="Sécurisation de la page"
  />
);

export default SecurityButton;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Edit/components/SecurityButton.js